import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useRealtimeKitClient, RealtimeKitProvider } from '@cloudflare/realtimekit-react';
import { RtkMeeting } from '@cloudflare/realtimekit-react-ui';

const MeetingPage = () => {
  const [searchParams] = useSearchParams();
  const authToken = searchParams.get('authToken');
  const [meeting, initMeeting] = useRealtimeKitClient();
  const initializedRef = useRef(false);

  // Prevent double-init (React StrictMode / re-renders)
  useEffect(() => {
    if (authToken && !initializedRef.current) {
      initializedRef.current = true;
      initMeeting({ authToken });
    }
  }, [authToken]);

  // Release the meeting lock reliably on tab close, refresh, or navigation away
  useEffect(() => {
    const leave = () => {
      try {
        meeting?.leaveRoom();
      } catch (e) {
        // ignore — meeting may already be torn down
      }
    };

    window.addEventListener('pagehide', leave);
    window.addEventListener('beforeunload', leave);

    return () => {
      window.removeEventListener('pagehide', leave);
      window.removeEventListener('beforeunload', leave);
      leave(); // also runs on React unmount (SPA navigation away)
    };
  }, [meeting]);

  if (!meeting) return <div>Joining meeting...</div>;

  return (
    <RealtimeKitProvider value={meeting}>
      <div style={{ height: '100vh', width: '100vw' }}>
        <RtkMeeting meeting={meeting} />
      </div>
    </RealtimeKitProvider>
  );
};

export default MeetingPage;